require('_stylesheets/sprite.sass');
require('./index.scss');
require('./filters/');

var configs = require('json!_data/configs.json');

angular.module('app', [
    'ngMessages',
    'ngLocale',
    'ui.router',
    'restangular',
    'pascalprecht.translate',
    'ui.mask',
    'vcRecaptcha',
    'ui-notification',
    'filters',
    'duScroll',
    'component-spinner',
    'angular-google-analytics',
    require('angular-sanitize'),
    require('angular-ui-bootstrap'),
    require('angular-dynamic-locale'),
    require('component-input'),
    require('angular-touch'),
    require('component-tabindex'),
    require('./directives/'),
    require('./directives/common'),
    require('./modules/warning-notification'),
    require('./modules/header'),
    require('./modules/frameHeader'),
    require('./modules/footer'),
    require('./modules/frameFooter'),
    require('./components/authentication'),
    require('./components/portal_api'),
    require('./components/slider'),
    require('./components/component-spinner-button'),
    require('./components/client-cards'),
    require('./components/client-bills'),
    require('./components/user-data-storage'),
    require('./components/localization'),
    require('./components/locations'),
    require('./components/dateFormater'),
    require('./components/static-categories'),
    require('./components/user-payment'),
    require('./components/amount-commission'),
    require('./components/counters'),
    require('./components/combobox'),
    require('./components/ct-payments'),
    require('./components/iban'),
    require('./components/google-pay'),
    require('./components/apple-pay'),
    require('./widgets/payments'),
    require('./pages/registration'),
    require('./pages/wrongBrowser'),
    require('./pages/main'),
    require('./pages/payment'),
    require('./pages/history'),
    require('./pages/login'),
    require('./pages/lookup'),
    require('./pages/404'),
    require('./pages/agreements-archive'),
    require('./pages/loginReminder'),
    // require('./pages/cardToCard'),
    require('./pages/accounts'),
    require('./pages/myPayments'),
    require('./pages/myCards'),
    require('./pages/services'),
    require('./pages/receipt'),
    require('./pages/templates'),
    require('./pages/passwordRecovery'),
    require('./pages/myElectricity'),
    require('./pages/shortLinks'),
    require('./pages/shortLinksService'),
    require('./pages/userSettings'),
    require('./pages/rates'),
    require('./pages/service'),
    require('./pages/serviceReceipt'),
    require('./pages/yasno'),
    // require('./pages/yasnoCtC'),
    require('./pages/yasnoP2P'),
    require('./pages/p2p'),
    require('./pages/booking'),
    require('./pages/households'),
    require('angular-input-masks')
])
    .config(config)
    .run(run)
    .value('configs',
        configs
    );

config.$inject = ['$stateProvider', '$locationProvider', '$urlRouterProvider', '$translateProvider', 'RestangularProvider', 'NotificationProvider', 'uiMask.ConfigProvider', 'AnalyticsProvider', '$compileProvider'];
function config($stateProvider, $locationProvider, $urlRouterProvider, $translateProvider, RestangularProvider, NotificationProvider, uiMaskConfigProvider, AnalyticsProvider, $compileProvider) {

    //TODO html5 style link
    // $locationProvider.html5Mode({
    //    enabled: true,
    //    requireBase: true
    // });

    $stateProvider
        .state('pages', {
            url: '/',
            abstract: true,
            template: require('./index.html'),

            resolve: {
                session: ['Authentication', function (Authentication) {
                    return Authentication.sessionStart();
                }],
                locale: ['tmhDynamicLocale', function(tmhDynamicLocale) {

                    var lang = 'ua';
                    if(localStorage) {
                        lang = localStorage.getItem('lang') || 'ua';
                    }

                    return tmhDynamicLocale.set(lang);
                }]
            }
        });
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?):|data:image|\//);
    $urlRouterProvider.otherwise('/main');

    require('_data/locale-ua.json');
    // require('_data/locale-ru.json');
    require('_data/locale-en.json');

    $translateProvider
        .preferredLanguage('ua')
        .fallbackLanguage('ua')
        // .useSanitizeValueStrategy('escape')
        .useStaticFilesLoader({
            prefix: '/data/locale-',
            suffix: '.json'
        });

    if (process.env.API_BASE_URL) {
        RestangularProvider.setBaseUrl(process.env.API_BASE_URL);
    } else if (process.env.NODE_ENV == 'development') {
        RestangularProvider.setBaseUrl('https://standalone2.fuib.com');
    }

    RestangularProvider.setFullResponse(true);

    NotificationProvider.setOptions({
        delay: 10000,
        startTop: 20,
        startRight: 100,
        verticalSpacing: 50,
        horizontalSpacing: 50,
        positionX: 'right',
        positionY: 'top'
    });

    uiMaskConfigProvider.clearOnBlur(false);
    uiMaskConfigProvider.addDefaultPlaceholder(false);
    uiMaskConfigProvider.eventsToHandle(['input', 'keyup', 'click', 'focus', 'paste']);

    // if ( window != window.top ) {
    //     /*a frame*/
    //     AnalyticsProvider
    //         .setAccount([
    //             { tracker: configs.googleAnalytics.tracker, name: 'payhubTracker' },
    //             { tracker: configs.googleAnalytics.pumb_tracker, name: 'pumbFrameTracker' }
    //         ])
    // } else {
    //     /*not a frame*/
    //     AnalyticsProvider
    //         .setAccount(configs.googleAnalytics.tracker)
    // }

    AnalyticsProvider
        .setAccount(configs.googleAnalytics.tracker)
        .setDomainName(configs.googleAnalytics.setDomainName)
        .useDisplayFeatures(configs.googleAnalytics.displayFeatures)
        .useCrossDomainLinker(false)
        .useECommerce(true, true)
        .setCurrency('UAH')
        .setPageEvent(configs.googleAnalytics.setPageEvent)
        .logAllCalls(true);

    if (configs.googleAnalytics.enterDebugMode) {
        AnalyticsProvider.enterDebugMode(true);
    }

}

run.$inject = ['$rootScope', '$location', '$state', '$http', '$timeout', 'Analytics', 'Authentication', 'Restangular', 'configs', 'Localization', '$translate'];
function run($rootScope, $location, $state, $http, $timeout, Analytics, Authentication, Restangular, configs, Localization, $translate) {
    $rootScope.globalLoader = true;

    $timeout(function () {
        $rootScope.globalLoader = false;
    }, 2000);

    $rootScope.NODE_ENV = process.env.NODE_ENV;

    Authentication.updateSessionTimer();

    $rootScope.auth = Authentication;
    $rootScope.captchaKey = configs.app.captchaKey;

    var search = $location.search();

    if (Object.keys(search).length) {

        if (search.iframe) {
            $rootScope.useFrame = true;
            Authentication.frameLogin = search.iframe;
        }

        if (search.l) {
            $rootScope.short_url = search.l;
            $location.search('l', null);
        }

        if (search.lang) {
            Localization.setLang(search.lang);
            $location.search('lang', null);
        }

        if (search.hide_title) {
            $rootScope.hide_title = true;
            $location.search('hide_title', null);
        }

        if (search.show_active_state) {
            $rootScope.show_active_state = true;
            $location.search('show_active_state', null);
        }
    }

    if(!$rootScope.useFrame && window){
        // Chat bot start
        window.onload = function() {
            (function(d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                js = d.createElement(s);
                js.id = id;
                js.src = "https://widget.sender.pumb.ua/build/init.js";
                fjs.parentNode.insertBefore(js, fjs, 'sender-widget');
            })(document, 'script');

            window.senderCallback = function() {
                SenderWidget.init({
                    companyId: "i285647377",
                    extCSSLink: "https://static.sender.pumb.ua/styles/style_payhub.css"
                });
            };
        };
        // Chat bot finish
    }

    //Marketing
    if(window) {
        search = window.location.search.split('=');
    }

    //Get cookies fnc for to check admitad_uid
    getCookie = function () {
        var ad_uid = "admitad_uid=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];

            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }

            if (c.indexOf(ad_uid) == 0) {
                delCookie();
                $rootScope.admitad_uid = c.substring(ad_uid.length, c.length);
            }
        }
    };


    delCookie = function() {
        document.cookie = 'aff_sub=' + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = 'aff_id=' + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = 'admitad_uid=' + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    };

    if ($location.$$search.aff_sub) {
        delCookie();
        document.cookie = 'aff_sub=' + $location.$$search.aff_sub;
        document.cookie = 'aff_id=' + $location.$$search.aff_id;
    }

    if ($location.$$search.admitad_uid) {
        $rootScope.admitad_uid = $location.$$search.admitad_uid;
    } else if (search[0] == '?admitad_uid') {
        $rootScope.admitad_uid = search[1];
    }

    if ($rootScope.admitad_uid) {
        delCookie();
        document.cookie = 'admitad_uid=' + $rootScope.admitad_uid;
    } else {
        getCookie();
    }

    if ($location.$$search.gclid) {
        $rootScope.gclid = $location.$$search.gclid;
    } else if (search[0] == '?gclid') {
        $rootScope.gclid = search[1];
    }

    if ($rootScope.gclid) {
        delCookie();
    }

    var TITLE_KEY_MAP = {
        'pages.main': 'PAGE_TITLES.MAIN',
        'pages.login': 'PAGE_TITLES.LOGIN',
        'pages.registration': 'PAGE_TITLES.REGISTRATION',
        'pages.services': 'PAGE_TITLES.SERVICES',
        'pages.payment': 'PAGE_TITLES.PAYMENT',
        'pages.history': 'PAGE_TITLES.HISTORY',
        'pages.mycards': 'PAGE_TITLES.MYCARDS',
        'pages.templates': 'PAGE_TITLES.TEMPLATES',
        'pages.rates': 'PAGE_TITLES.RATES',
        'pages.password-recovery': 'PAGE_TITLES.PASSWORD_RECOVERY',
        'pages.lookup': 'PAGE_TITLES.LOOKUP',
        'pages.accounts': 'PAGE_TITLES.ACCOUNTS'
    };
    var DEFAULT_TITLE_KEY = 'PAGE_TITLES.DEFAULT';
    var FALLBACK_TITLE = 'PayHub - сервіс онлайн-оплат від банку ПУМБ.';

    function updateDocumentTitle(state) {
        var key = DEFAULT_TITLE_KEY;

        if (state && state.data && state.data.pageTitleKey) {
            key = state.data.pageTitleKey;
        } else if (state && state.name && TITLE_KEY_MAP[state.name]) {
            key = TITLE_KEY_MAP[state.name];
        }

        var translated = $translate.instant(key);

        if (!translated || translated === key) {
            var defaultTranslated = $translate.instant(DEFAULT_TITLE_KEY);
            document.title = defaultTranslated && defaultTranslated !== DEFAULT_TITLE_KEY ? defaultTranslated : FALLBACK_TITLE;
        } else {
            document.title = translated;
        }
    }

    $rootScope.$on('$stateChangeSuccess',function (event, toState) {
        $rootScope.STATE_GOIN = false;
        if(window) {
            window.scrollTo(0,0);
        }
        updateDocumentTitle(toState);
    });

    updateDocumentTitle($state.current);

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        var isLogged = Authentication.isLogged;
        $rootScope.STATE_GOIN = true;

        if(navigator.appVersion.indexOf("MSIE 9.")!=-1){
            $state.go("pages.wrongBrowser").then(function () {
                $rootScope.STATE_GOIN = false;
                if(window) {
                    window.scrollTo(0,0);
                }
            });
        }
        if (!isLogged && toState.data.restricted) {
            event.preventDefault();

            $state.go('pages.main').then(function () {
                $rootScope.STATE_GOIN = false;
                if(window) {
                    window.scrollTo(0,0);
                }
            });

        }

        if (isLogged && toState.name == 'pages.main') {
            event.preventDefault();

            $state.go('pages.services').then(function () {
                $rootScope.STATE_GOIN = false;
                if(window) {
                    window.scrollTo(0,0);
                }
            });
        }
    });

    Restangular.addResponseInterceptor(function (data, operation, what, url, response, deferred) {
        if (typeof(data) == "object" && data.ready && data.data) {
            data = data.data;
        }

        if (response.status == 200 && operation == 'post') {
            Authentication.updateSessionTimer();
        }

        return data;
    });

    Restangular.setErrorInterceptor(function(response, deferred, responseHandler) {

        if (response.status == 403) {
            if (Authentication.isLogged) {
                Authentication.logout(true);
            } else {
                Authentication.sessionStart(true).then(function (token) {
                    Authentication.setAuthHeader(response.config.headers, token);
                    $http(response.config).then(responseHandler, deferred.reject);
                });
            }

            return false;
        }

        return true;
    });

    Restangular.setFullRequestInterceptor(function (element, operation, route, url, headers, params, httpConfig) {
        Authentication.setAuthHeader(headers);
        Authentication.httpMethod(operation, headers);
    });

    $rootScope.loaders = 0;
    $rootScope.startLoader = function() {
        ++$rootScope.loaders;
    };
    $rootScope.finishLoader = function() {
        --$rootScope.loaders;
    };

    $rootScope.$on('$viewContentLoaded', function(){
        var script = document.createElement("SCRIPT");
        script.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.5.0/jquery.min.js';
        script.type = 'text/javascript';
        script.onload = function() {
            if(window) {
                var $ = window.jQuery;
            }

        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/app.js
 ** module id = 0
 ** module chunks = 1
 **/